<template>
    <div class="col-md-9">
        <div class="tab-content">
            <!-- <dashboard v-show="hasProjects" :role="role"></dashboard> -->
            <overview v-show="currentProject" :role="role" :project="currentProject"></overview>
            <work-orders v-show="currentProject" :role="role" :user="user" :project="currentProject"></work-orders>
            <work-order-calendar v-show="currentProject" :role="role" :project="currentProject"></work-order-calendar>
            <change-orders v-show="currentProject" :role="role" :user="user" :project="currentProject"></change-orders>
            <selections v-show="currentProject"  :role="role" :user="user" :project="currentProject"></selections>
        </div>
    </div>
</template>

<script>
    export default {
        props: ['role', 'user', 'team'],

        created: function() {
            let vm = this;
            Bus.$on('set-current-project', function (project) {
                vm.currentProject = project;
                return true;
            });

            Bus.$on('refresh-current-project', function() {
                vm.refreshProject();
                return true;
            });

            Bus.$on('projects-loading-status', function(isLoading) {
                vm.projectsLoading = isLoading;
                return true;
            });

            Bus.$on('has-projects', function(hasProjects) {
                vm.hasProjects = hasProjects;
                return true;
            });
        },

        mounted: function() {

        },

        data: function() {
            return {
                currentProject: null,
                projectsLoading: true,
                hasProjects: false
            };
        },

        computed: {
        },

        methods: {
            updateCurrentProject: function(project) {
                this.currentProject = project;
            },

            refreshProject: function() {
                axios.get('/api/projects/' + this.currentProject.id)
                    .then(response => {
                        this.updateCurrentProject(response.data);
                    })
                    .catch(error => {
                        console.log(error);
                    });
            }
        }
    }
</script>
